import React from "react";
import image1 from "../../assets/image1.jpg";
import image2 from "../../assets/image2.jpg";
import image3 from "../../assets/image3.jpg";
import image4 from "../../assets/image4.jpg";
import nb from '../../assets/nb.png';
import adidas from '../../assets/adidas.png'
import nike from '../../assets/nike.png'
import puma from '../../assets/puma.png'
import tick from "../../assets/tick.png";
import "./Reasons.css";
const Reasons = () => {
  return (
    <div className="Reasons" id='reasons'>
      <div className="left-r">
        <img src={image1} alt="" />
        <img src={image2} alt="" />
        <img src={image3} alt="" />
        <img src={image4} alt="" />
      </div>
      <div className="right-r">
        <span>Algunos motivos</span>
        <div>
          <span className="stroke-text">Por qué</span>
          <span>elegirnos?</span>
        </div>
        <div className="details-r">
          <div>
            <img src={tick} alt="" />
            <span>más de 140+ entrenadores personales</span>
          </div>
          <div>
            <img src={tick} alt="" />
            <span>entrena más inteligente y más rápido que antes</span>
          </div>
          <div>
            <img src={tick} alt="" />
            <span>1 entrenamiento gratis si eres nuevo miembro</span>
          </div>
          <div>
            <img src={tick} alt="" />
            <span>reliable partners</span>
          </div>
        </div>
        <span style={{color: "var(--gray)", fontWeight: "normal"}}>NUESTROS PATROCINADORES</span>
        <div className="partners">
              <img src={nb} alt="" />
              <img src={adidas} alt="" />
              <img src={nike} alt="" />
              <img src={puma} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Reasons;
